/**
 * CSRF token utilities for client-side security
 * Works with the server's double-submit cookie pattern
 */

/**
 * Get CSRF token from cookie
 * The server sets a 'csrfToken' cookie that we need to echo back in the X-CSRF-Token header
 */
export function getCsrfToken(): string | null {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'csrfToken') {
      return value;
    }
  }
  return null;
}

/**
 * Check if a request method requires CSRF protection
 */
export function requiresCsrfToken(method: string): boolean {
  const upperMethod = method.toUpperCase();
  return ['POST', 'PUT', 'PATCH', 'DELETE'].includes(upperMethod);
}
